var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { MORE_RESULTS_TYPE } from '../globalSearchUtils';
import { createReactTooltip } from '../../common/tooltip';
import { WordHighlighter } from './WordHighlighter';
import AccurityIcon from '../../icon/components/AccurityIcon';
import { objectTypeToIconName } from '../../icon/utils';
export var GlobalSearchListItem = function (_a) {
    var objectType = _a.objectType, name = _a.name, synonym = _a.synonym, description = _a.description, id = _a.id, relatedObjectName = _a.relatedObjectName, searchTerm = _a.searchTerm;
    // don't use highlighting for More Results item
    if (objectType === MORE_RESULTS_TYPE) {
        return (React.createElement(GlobalSearchListItemContainer, null,
            React.createElement("div", { className: "globalSearchListItem__name" }, name)));
    }
    var _b = createReactTooltip({ value: name, subtitle: relatedObjectName, description: description }, 'global-search'), tooltipAnchorParams = _b.tooltipAnchorParams, tooltipElement = _b.tooltipElement;
    return (React.createElement(GlobalSearchListItemContainer, __assign({}, tooltipAnchorParams),
        React.createElement(AccurityIcon, { className: "globalSearchListItem__icon", iconName: objectTypeToIconName(objectType) }),
        React.createElement(WordHighlighter, { className: "globalSearchListItem__name", text: getText(name, relatedObjectName, synonym), searchTerm: searchTerm }),
        description && React.createElement(WordHighlighter, { className: "globalSearchListItem__description", text: (description === null || description === void 0 ? void 0 : description.plainTextValue) || '', searchTerm: searchTerm }),
        tooltipElement));
};
var getText = function (name, relatedObjectName, synonym) {
    var text = name;
    if (relatedObjectName) {
        text = relatedObjectName + "." + text;
    }
    if (synonym) {
        text = text + " (" + synonym + ")";
    }
    return text;
};
var GlobalSearchListItemContainer = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (React.createElement("div", __assign({ className: "globalSearchListItem" }, rest), children));
};
export default GlobalSearchListItem;
//# sourceMappingURL=GlobalSearchListItem.js.map